// extracted by mini-css-extract-plugin
export default {"wrapper":"LandscapeProjectsAddProjectsImpactIndicatorsPage_wrapper__lZPX8"};